import React from 'react';
import { Phone, MessageCircle } from 'lucide-react';

const WA_URL = 'https://wa.me/919246887272?text=Hi%2C%20I%20am%20interested%20in%20an%20admission%20enquiry%20at%20Sri%20Aurobindo%20Montessori%20School';

export default function MobileBottomBar() {
  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-40 lg:hidden bg-white border-t-2 border-blue-100 shadow-[0_-4px_20px_rgba(30,58,138,0.1)]"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
      data-testid="mobile-bottom-bar"
    >
      <div className="grid grid-cols-2 h-14">
        <a
          href="tel:9246887272"
          data-testid="mobile-bar-call"
          className="flex items-center justify-center gap-2 text-[#1E3A8A] font-bold text-sm border-r border-blue-100 hover:bg-blue-50 active:bg-blue-100 transition-colors"
        >
          <Phone size={17} strokeWidth={2.5} />
          Call Us
        </a>
        <a
          href={WA_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="mobile-bar-whatsapp"
          className="flex items-center justify-center gap-2 bg-[#25D366] text-white font-bold text-sm hover:bg-[#128C7E] active:bg-[#075E54] transition-colors"
        >
          <MessageCircle size={17} strokeWidth={2.5} />
          WhatsApp
        </a>
      </div>
    </div>
  );
}
